import { StreamActions, StreamElement } from "@hotwired/turbo"
import { isHTMLElement } from "~/types/types.util"

// Adds `by` (can be negative) to the number in the [data-size-value] element of the targets and updates their text.
// data-size-value and data-size-label are markers, they have no value. They tell this action which elements to update:
// - [data-size-value] elements show the number
// - [data-size-label] elements show the number followed by their data-singular or data-plural word
// <turbo-stream action="adjust_size" target="nuggits_count" by="-2"></turbo-stream>
// The Rails side is TurboStreamActionsHelper#adjust_size
StreamActions.adjust_size = function (this: StreamElement) {
  const by = Number(this.getAttribute("by"))

  this.targetElements.filter(isHTMLElement).forEach((element) => {
    const values = element.querySelectorAll("[data-size-value]")
    if (values.length === 0) return

    const size = Math.max(0, Number(values[0].textContent) + by)

    values.forEach((value) => (value.textContent = String(size)))
    element.querySelectorAll<HTMLElement>("[data-size-label]").forEach((label) => {
      const word = size === 1 ? label.dataset.singular : label.dataset.plural
      label.textContent = `${size} ${word}`
    })
  })
}
